import React from 'react';

import { ScreenProps } from '../ScreenBase';
import styles from './rate.module.css';

import face1 from '../../../../assets/icons/face1.svg';
import face2 from '../../../../assets/icons/face2.svg';
import face3 from '../../../../assets/icons/face3.svg';
import face4 from '../../../../assets/icons/face4.svg';
import face5 from '../../../../assets/icons/face5.svg';
import NextButton from '../NextButton';
import commonStyles from '../screenbase.module.css';

const faces = [face5, face4, face3, face2, face1];
const alts = [
  'Emoticon furioso',
  'Emoticon inconforme',
  'Emoticon neutro',
  'Emoticon sonriendo',
  'Emoticon carcajada',
];
class Rate extends React.Component<ScreenProps> {
  state = {
    value: null,
  };

  setValue = (value?: number) => {
    const { onSubmit, locked } = this.props;
    if (!locked) {
      onSubmit({ value });
      this.setState({ value });
    }
  };

  renderFace = (value: number, image: string, alt: string) => {
    return (
      <div
        key={`f${value}`}
        className={`${styles.face} ${
          this.state.value === value ? styles.selected : ''
        } ${image.startsWith('data:') ? styles.custom : ''}`}
        onClick={() => this.setValue(value)}
      >
        <img src={image} alt={alt} />
      </div>
    );
  };

  render() {
    const {
      data: { max_value, required, extended_props },
    } = this.props;
    const {
      button_text,
      icon_1,
      icon_2,
      icon_3,
      icon_4,
      icon_5,
      min_label,
      max_label,
    } = extended_props || {};
    const custom_icons_array = [icon_1, icon_2, icon_3, icon_4, icon_5];

    let idx = 1;
    let elems = [];

    for (let i = 1; i <= 5; i++) {
      if (max_value === 3 && i % 2 === 0) continue;
      elems.push(
        this.renderFace(
          idx,
          custom_icons_array[i - 1]
            ? `data:image/svg+xml;base64,${btoa(custom_icons_array[i - 1])}`
            : faces[i - 1],
          alts[i - 1]
        )
      );
      idx++;
    }

    return (
      <>
        <div className={styles.faces}>{elems}</div>
        {(min_label || max_label) && (
          <div className={styles.labels}>
            <div className={commonStyles.note}>{min_label || ''}</div>
            <div className={commonStyles.note}>{max_label || ''}</div>
          </div>
        )}

        <NextButton
          visible={!required}
          type='ghost'
          text={button_text || 'Omitir'}
          onClick={() => this.setValue()}
        />
      </>
    );
  }
}

export default Rate;
